import { forwardRef, useContext } from 'react';

import { ButtonProps, createStyles, withStyles } from '@material-ui/core';

import { DialogComposite } from '../DialogComposite';
import { StepContext } from './context';

const styles = createStyles({
  root: {},
});

export type SubmitProps = Omit<ButtonProps, 'classes'> &
  Partial<Pick<ButtonProps, 'classes'>>;

const Submit = forwardRef<HTMLButtonElement, SubmitProps>((props, ref) => {
  const { forceReview, seenEverything } = useContext(StepContext);
  const { disabled: disabledProps, ...rest } = props;
  const disabled = (forceReview && !seenEverything) || disabledProps;

  return (
    <DialogComposite.Actions.Submit
      ref={ref}
      disabled={disabled}
      {...rest}
      type="submit"
    />
  );
});

export default withStyles(styles)(Submit);
